import React from 'react';
import { useNavigate } from 'react-router-dom';
import { removeAuthToken, removeUserInfo, getUserInfo } from '../utils/auth';

const Header = ({ onToggleSidebar, sidebarOpen }) => {
  const navigate = useNavigate();
  const userInfo = getUserInfo();

  const handleTitleClick = () => {
    navigate('/products');
  };

  const handleLogout = () => {
    if (window.confirm('로그아웃 하시겠습니까?')) {
      removeAuthToken();
      removeUserInfo();
      localStorage.removeItem('tokenExpiresAt');
      navigate('/login');
    }
  };

  return (
    <div className="bg-white px-5 py-4 shadow-md flex justify-between items-center md:px-5 md:py-4">
      <div className="flex items-center gap-4">
        <button 
          onClick={onToggleSidebar}
          className="bg-none border-none text-2xl cursor-pointer text-slate-700 p-1 rounded transition-colors hover:bg-gray-50"
        >
          ☰
        </button>
        <h1 
          className="m-0 text-xl text-slate-700 md:text-xl cursor-pointer hover:text-blue-600 transition-colors"
          onClick={handleTitleClick}
        >
          CST Product Manager
        </h1>
      </div>
      <div className="flex items-center gap-3">
        <span className="text-slate-700 font-medium hidden md:inline">
          {userInfo?.name || userInfo?.username || '관리자'}
        </span>
        <button 
          onClick={handleLogout}
          className="text-slate-700 font-medium hidden md:inline hover:text-blue-600 transition-colors cursor-pointer"
        >
          로그아웃
        </button>
      </div>
    </div>
  );
};

export default Header;